import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowCornerDownLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-corner-down-left"} maskId="square-filled-radius-0-stroke-1-IconArrowCornerDownLeft"><path fillRule="evenodd" clipRule="evenodd" d="M20.2071 4V14.5H4.91422L8.91421 10.5L8.20711 9.79289L3 15L8.20711 20.2071L8.91421 19.5L4.91422 15.5H21.2071V4H20.2071Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowCornerDownLeft;
